/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Form, Row, Select, Checkbox, Button } from 'antd'
import { MinusCircleOutlined } from '@ant-design/icons'
import { FC } from 'react'
import { CustomFormInstance } from '../../../../types'
import { MachineForm } from '../types'
import {
    StyledSpan,
    StyledFormItem,
    StyledInput,
    StyledInputOptional,
} from '../methods.styles'
import { connectionOptions, connectionRelation } from '../../../../const'
import { extractComponentName } from '../../../functions'

type Props = {
    form: CustomFormInstance<MachineForm>
}

// type Values = MachineForm

const ImportantComponentConnections: FC<Props> = ({ form }) => {
    const handleConnectionTypeChange = (field: any) => () => {
        const name = 'importantComponentsConnections'
        const formValue: any =
            form.getFieldValue<MachineForm['importantComponentsConnections']>(
                name
            )
        const updateFormValue = formValue.map((value: any, index: number) => {
            if (index === field.key) {
                value.subConnectionType = ''
            }
            return value
        })
        form.setFieldsValue({ [name]: updateFormValue })
    }
    return (
        <Form.List name="importantComponentsConnections">
            {(fields, { add, remove }) => {
                const primaryOptions = form.getFieldValue<
                    MachineForm['partsOfIndependentClaim']
                >('partsOfIndependentClaim')
                const formatedOptions = primaryOptions.map((item: string) => {
                    return extractComponentName(item, form)
                })
                const connectionTypes = form.getFieldValue<
                    MachineForm['importantComponentsConnections']
                >('importantComponentsConnections')
                return (
                    <>
                        {fields.map((field) => (
                            <Form.Item style={{ marginBottom: '24px' }}>
                                <Row align="middle" gutter={[12, 0]}>
                                    <Col span={10}>
                                        <Form.Item noStyle shouldUpdate>
                                            {() => (
                                                <Form.Item
                                                    {...field}
                                                    label="1st component"
                                                    name={[
                                                        field.name,
                                                        '1stComponent',
                                                    ]}
                                                    fieldKey={[
                                                        field.fieldKey as number,
                                                        '1stComponent',
                                                    ]}
                                                    hasFeedback
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                '1st component is required',
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        options={formatedOptions.map(
                                                            (
                                                                item: string,
                                                                index: number
                                                            ) => ({
                                                                value: primaryOptions[
                                                                    index
                                                                ],
                                                                label: item,
                                                            })
                                                        )}
                                                    />
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col flex={1}>
                                        <Form.Item noStyle shouldUpdate>
                                            {() => (
                                                <Form.Item
                                                    {...field}
                                                    label="2nd component"
                                                    name={[
                                                        field.name,
                                                        '2ndComponent',
                                                    ]}
                                                    fieldKey={[
                                                        field.fieldKey as number,
                                                        '2ndComponent',
                                                    ]}
                                                    hasFeedback
                                                    rules={[
                                                        {
                                                            required: true,
                                                            message:
                                                                '2nd component is required',
                                                        },
                                                    ]}
                                                >
                                                    <Select
                                                        options={formatedOptions.map(
                                                            (
                                                                item: string,
                                                                index: number
                                                            ) => ({
                                                                value: primaryOptions[
                                                                    index
                                                                ],
                                                                label: item,
                                                            })
                                                        )}
                                                    />
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={2.5}>
                                        <MinusCircleOutlined
                                            className="dynamic-delete-button"
                                            onClick={() => remove(field.name)}
                                            style={{
                                                color: '#f00',
                                                fontSize: '1.6rem',
                                                marginTop: '0.6rem',
                                            }}
                                        />
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item
                                            name={[field.name, 'notSet']}
                                            valuePropName="checked"
                                            style={{ marginBottom: '20px' }}
                                        >
                                            <Checkbox>
                                                I want to describe the
                                                connection
                                            </Checkbox>
                                        </Form.Item>
                                    </Col>
                                    {!form.getFieldValue<
                                        MachineForm['importantComponentsConnections']
                                    >('importantComponentsConnections')[
                                        field.name
                                    ]?.notSet ? (
                                        <Col span={24}>
                                            <Form.Item noStyle shouldUpdate>
                                                {() => (
                                                    <Form.Item
                                                        {...field}
                                                        label="Connection type"
                                                        name={[
                                                            field.name,
                                                            'connectionType',
                                                        ]}
                                                        fieldKey={[
                                                            field.fieldKey as number,
                                                            'connectionType',
                                                        ]}
                                                        hasFeedback
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message:
                                                                    'Connection type is required',
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            onChange={handleConnectionTypeChange(
                                                                field
                                                            )}
                                                            options={
                                                                connectionOptions
                                                            }
                                                        />
                                                    </Form.Item>
                                                )}
                                            </Form.Item>
                                            {connectionRelation[
                                                connectionTypes[field.name]
                                                    ?.connectionType
                                            ] ? (
                                                <Form.Item noStyle shouldUpdate>
                                                    {() => (
                                                        <Form.Item
                                                            {...field}
                                                            label=""
                                                            name={[
                                                                field.name,
                                                                'subConnectionType',
                                                            ]}
                                                            fieldKey={[
                                                                field.fieldKey as number,
                                                                'subConnectionType',
                                                            ]}
                                                            // hasFeedback
                                                        >
                                                            <Select
                                                                options={
                                                                    connectionRelation[
                                                                        connectionTypes[
                                                                            field
                                                                                .name
                                                                        ]
                                                                            ?.connectionType
                                                                    ]
                                                                }
                                                            />
                                                        </Form.Item>
                                                    )}
                                                </Form.Item>
                                            ) : null}
                                        </Col>
                                    ) : (
                                        <Col span={24}>
                                            <Form.Item
                                                noStyle
                                                name={[
                                                    field.name,
                                                    'additionalConnectionInfo',
                                                ]}
                                                rules={[
                                                    {
                                                        validator: async () => {
                                                            const importantComponentsConnections =
                                                                form.getFieldValue<
                                                                    MachineForm['importantComponentsConnections']
                                                                >(
                                                                    'importantComponentsConnections'
                                                                )[field.key]
                                                            if (
                                                                importantComponentsConnections &&
                                                                importantComponentsConnections.notSet
                                                            ) {
                                                                const errorList =
                                                                    []
                                                                // if (
                                                                //     importantComponentsConnections[
                                                                //         '1stPart'
                                                                //     ] == null ||
                                                                //     importantComponentsConnections[
                                                                //         '1stPart'
                                                                //     ] === ''
                                                                // ) {
                                                                //     errorList.push(
                                                                //         '1st part of description is required'
                                                                //     )
                                                                // }
                                                                if (
                                                                    importantComponentsConnections[
                                                                        '2ndPart'
                                                                    ] == null ||
                                                                    importantComponentsConnections[
                                                                        '2ndPart'
                                                                    ] === ''
                                                                ) {
                                                                    errorList.push(
                                                                        ' 2nd part of description is required'
                                                                    )
                                                                }
                                                                // if (
                                                                //     importantComponentsConnections[
                                                                //         '3rdPart'
                                                                //     ] == null ||
                                                                //     importantComponentsConnections[
                                                                //         '3rdPart'
                                                                //     ] === ''
                                                                // ) {
                                                                //     errorList.push(
                                                                //         ' 3rd part of description is required'
                                                                //     )
                                                                // }
                                                                if (
                                                                    errorList.length >
                                                                    0
                                                                ) {
                                                                    throw new Error(
                                                                        errorList.toString()
                                                                    )
                                                                }
                                                            }
                                                        },
                                                    },
                                                ]}
                                            >
                                                <StyledFormItem
                                                    name={[
                                                        field.name,
                                                        '1stPart',
                                                    ]}
                                                >
                                                    <StyledInputOptional
                                                        type="text"
                                                        style={{
                                                            width: '150px',
                                                        }}
                                                    />
                                                </StyledFormItem>
                                                <StyledSpan>
                                                    the{' '}
                                                    {extractComponentName(
                                                        form.getFieldValue<
                                                            MachineForm['importantComponentsConnections']
                                                        >(
                                                            'importantComponentsConnections'
                                                        )[field.key]?.[
                                                            '1stComponent'
                                                        ],
                                                        form
                                                    ) ?? '1st Component'}
                                                </StyledSpan>
                                                <StyledFormItem
                                                    name={[
                                                        field.name,
                                                        '2ndPart',
                                                    ]}
                                                >
                                                    <StyledInput
                                                        type="text"
                                                        style={{
                                                            width: '150px',
                                                        }}
                                                    />
                                                </StyledFormItem>
                                                <StyledSpan>
                                                    the{' '}
                                                    {extractComponentName(
                                                        form.getFieldValue<
                                                            MachineForm['importantComponentsConnections']
                                                        >(
                                                            'importantComponentsConnections'
                                                        )[field.key]?.[
                                                            '2ndComponent'
                                                        ],
                                                        form
                                                    ) ?? '2nd Component'}
                                                </StyledSpan>
                                                <StyledFormItem
                                                    name={[
                                                        field.name,
                                                        '3rdPart',
                                                    ]}
                                                >
                                                    <StyledInputOptional
                                                        type="text"
                                                        style={{
                                                            width: '150px',
                                                        }}
                                                    />
                                                </StyledFormItem>
                                            </Form.Item>
                                        </Col>
                                    )}
                                </Row>
                            </Form.Item>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block>
                                Add connection
                            </Button>
                        </Form.Item>
                    </>
                )
            }}
        </Form.List>
    )
}

export default ImportantComponentConnections
